import { render } from "./MaterialInfo.vue?vue&type=template&id=e77acfb2"
import script from "./MaterialInfo.vue?vue&type=script&lang=js"
export * from "./MaterialInfo.vue?vue&type=script&lang=js"

import "./MaterialInfo.vue?vue&type=style&index=0&id=e77acfb2&lang=less"

import exportComponent from "/Users/islibaodong/IdeaProjects/2024/Titan-Frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__